// Add Campaign Users
export const ADD_CAMPAIGN_USERS_REQUEST = 'ADD_CAMPAIGN_USERS_REQUEST';
export const ADD_CAMPAIGN_USERS_DONE = 'ADD_CAMPAIGN_USERS_DONE';
export const ADD_CAMPAIGN_USERS_FAILED = 'ADD_CAMPAIGN_USERS_FAILED';
